var _path, _rect, _path2, _path3, _path4, _ellipse, _ellipse2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse3, _path17, _rect2, _rect3, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnTimePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07521 5.7904C5.03816 5.7904 4.19746 6.6311 4.19746 7.66816V30.8543C4.19746 31.8914 5.03816 32.732 6.07521 32.732H33.5067C34.5438 32.732 35.3845 31.8913 35.3845 30.8543V7.66815C35.3845 6.6311 34.5438 5.7904 33.5067 5.7904H31.2207C30.9051 5.7904 30.6493 5.53454 30.6493 5.21891V3.74937C30.6493 3.34357 30.3203 3.0146 29.9145 3.0146H26.159C25.7532 3.0146 25.4242 3.34357 25.4242 3.74937V5.21891C25.4242 5.53454 25.1683 5.7904 24.8527 5.7904H13.5862C13.2706 5.7904 13.0147 5.53454 13.0147 5.21891V3.74937C13.0147 3.34357 12.6858 3.0146 12.28 3.0146H9.66743C9.26163 3.0146 8.93266 3.34357 8.93266 3.74937V5.21891C8.93266 5.53454 8.67679 5.7904 8.36117 5.7904H6.07521Z",
    fill: "#A2BDFF",
    stroke: "url(#paint0_linear_996_3560)",
    strokeWidth: 0.489848
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 17.5049,
    y: 12.2401,
    width: 4.7352,
    height: 2.28596,
    rx: 0.489848,
    fill: "#A3BEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2952 12.5459V13.9136H19.0209V13.024L18.6545 13.9136H18.4468L18.0785 13.024V13.9136H17.8041V12.5459H18.1157L18.5507 13.5628L18.9857 12.5459H19.2952ZM20.0485 13.9312C19.944 13.9312 19.8499 13.9083 19.7663 13.8626C19.6827 13.8156 19.6167 13.7496 19.5684 13.6647C19.5214 13.5798 19.4979 13.4819 19.4979 13.3708C19.4979 13.2598 19.522 13.1618 19.5704 13.0769C19.62 12.992 19.6873 12.9267 19.7722 12.881C19.8571 12.8339 19.9518 12.8104 20.0563 12.8104C20.1608 12.8104 20.2555 12.8339 20.3404 12.881C20.4253 12.9267 20.4919 12.992 20.5403 13.0769C20.5899 13.1618 20.6147 13.2598 20.6147 13.3708C20.6147 13.4819 20.5893 13.5798 20.5383 13.6647C20.4887 13.7496 20.4207 13.8156 20.3345 13.8626C20.2496 13.9083 20.1543 13.9312 20.0485 13.9312ZM20.0485 13.6922C20.0981 13.6922 20.1445 13.6804 20.1876 13.6569C20.232 13.6321 20.2673 13.5955 20.2934 13.5472C20.3195 13.4988 20.3326 13.4401 20.3326 13.3708C20.3326 13.2676 20.3051 13.1886 20.2503 13.1337C20.1967 13.0776 20.1308 13.0495 20.0524 13.0495C19.974 13.0495 19.908 13.0776 19.8545 13.1337C19.8022 13.1886 19.7761 13.2676 19.7761 13.3708C19.7761 13.474 19.8016 13.5537 19.8525 13.6099C19.9048 13.6647 19.9701 13.6922 20.0485 13.6922ZM21.4175 12.8124C21.5468 12.8124 21.6513 12.8535 21.731 12.9358C21.8107 13.0168 21.8505 13.1305 21.8505 13.2768V13.9136H21.5762V13.314C21.5762 13.2278 21.5546 13.1618 21.5115 13.1161C21.4684 13.0691 21.4096 13.0456 21.3352 13.0456C21.2594 13.0456 21.1993 13.0691 21.1549 13.1161C21.1118 13.1618 21.0903 13.2278 21.0903 13.314V13.9136H20.8159V12.8281H21.0903V12.9633C21.1268 12.9162 21.1732 12.8797 21.2294 12.8535C21.2869 12.8261 21.3496 12.8124 21.4175 12.8124Z",
    fill: "#A3BEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M4.77051 7.66808C4.77051 6.94665 5.35534 6.36182 6.07677 6.36182H33.5083C34.2297 6.36182 34.8145 6.94665 34.8145 7.66808V11.4236H4.77051V7.66808Z",
    fill: "#1F297D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.7333 17.8781V15.856H21.511V27.2832H19.2537V17.8781H17.7333Z",
    fill: "#1F297D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.6049,
    cy: 35.916,
    rx: 6.85787,
    ry: 1.63283,
    fill: "url(#paint1_radial_996_3560)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.70651,
    cy: 32.8136,
    rx: 6.85787,
    ry: 1.63283,
    fill: "url(#paint2_radial_996_3560)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64551 29.7943H2.40058V32.0482C2.40058 32.3439 2.63434 32.5554 2.87512 32.6977C3.1323 32.8497 3.48814 32.9781 3.90639 33.0827C4.74664 33.2927 5.89447 33.4201 7.15324 33.4201C8.41201 33.4201 9.55983 33.2927 10.4001 33.0827C10.8183 32.9781 11.1742 32.8497 11.4314 32.6977C11.6721 32.5554 11.9059 32.3439 11.9059 32.0482V29.7943H11.661H11.416C11.416 29.8099 11.3975 29.8948 11.1821 30.0221C10.9831 30.1398 10.6788 30.2542 10.2813 30.3536C9.49006 30.5514 8.38402 30.6764 7.15324 30.6764C5.92246 30.6764 4.81642 30.5514 4.02519 30.3536C3.6277 30.2542 3.3234 30.1398 3.12437 30.0221C2.90895 29.8948 2.89043 29.8099 2.89043 29.7943H2.64551Z",
    fill: "#F7CC74",
    stroke: "url(#paint3_linear_996_3560)",
    strokeWidth: 0.489848
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64551 27.5405H2.40058V29.7943C2.40058 30.09 2.63434 30.3015 2.87512 30.4438C3.1323 30.5958 3.48814 30.7242 3.90639 30.8288C4.74664 31.0389 5.89447 31.1662 7.15324 31.1662C8.41201 31.1662 9.55983 31.0389 10.4001 30.8288C10.8183 30.7242 11.1742 30.5958 11.4314 30.4438C11.6721 30.3015 11.9059 30.09 11.9059 29.7943V27.5405H11.661H11.416C11.416 27.556 11.3975 27.6409 11.1821 27.7683C10.9831 27.8859 10.6788 28.0003 10.2813 28.0997C9.49006 28.2975 8.38402 28.4225 7.15324 28.4225C5.92246 28.4225 4.81642 28.2975 4.02519 28.0997C3.6277 28.0003 3.3234 27.8859 3.12437 27.7683C2.90895 27.6409 2.89043 27.556 2.89043 27.5405H2.64551Z",
    fill: "#F7CC74",
    stroke: "url(#paint4_linear_996_3560)",
    strokeWidth: 0.489848
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64551 25.2866H2.40058V27.5405C2.40058 27.8361 2.63434 28.0476 2.87512 28.19C3.1323 28.342 3.48814 28.4704 3.90639 28.5749C4.74664 28.785 5.89447 28.9123 7.15324 28.9123C8.41201 28.9123 9.55983 28.785 10.4001 28.5749C10.8183 28.4704 11.1742 28.342 11.4314 28.19C11.6721 28.0476 11.9059 27.8361 11.9059 27.5405V25.2866H11.661H11.416C11.416 25.3021 11.3975 25.3871 11.1821 25.5144C10.9831 25.632 10.6788 25.7465 10.2813 25.8458C9.49006 26.0436 8.38402 26.1686 7.15324 26.1686C5.92246 26.1686 4.81642 26.0436 4.02519 25.8458C3.6277 25.7465 3.3234 25.632 3.12437 25.5144C2.90895 25.3871 2.89043 25.3021 2.89043 25.2866H2.64551Z",
    fill: "#F7CC74",
    stroke: "url(#paint5_linear_996_3560)",
    strokeWidth: 0.489848
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15324 23.9147C5.89447 23.9147 4.74664 24.0421 3.90639 24.2521C3.48814 24.3567 3.1323 24.4851 2.87512 24.6371C2.63434 24.7794 2.40058 24.9909 2.40058 25.2866C2.40058 25.5823 2.63434 25.7938 2.87512 25.9361C3.1323 26.0881 3.48814 26.2165 3.90639 26.3211C4.74664 26.5311 5.89447 26.6585 7.15324 26.6585C8.41201 26.6585 9.55983 26.5311 10.4001 26.3211C10.8183 26.2165 11.1742 26.0881 11.4314 25.9361C11.6721 25.7938 11.9059 25.5823 11.9059 25.2866C11.9059 24.9909 11.6721 24.7794 11.4314 24.6371C11.1742 24.4851 10.8183 24.3567 10.4001 24.2521C9.55983 24.0421 8.41201 23.9147 7.15324 23.9147Z",
    fill: "#FFDF9D",
    stroke: "url(#paint6_linear_996_3560)",
    strokeWidth: 0.489848
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36616 25.6849L5.9307 25.2564H5.8197V25.6849H5.33301V24.55H6.16408C6.32346 24.55 6.45818 24.5656 6.56823 24.5966C6.67828 24.6276 6.76082 24.6704 6.81585 24.725C6.87087 24.7785 6.89839 24.8401 6.89839 24.9096C6.89839 24.992 6.85759 25.0621 6.776 25.1199C6.69631 25.1777 6.57962 25.2173 6.42593 25.2387L6.90408 25.6849H6.36616ZM5.8197 25.0685H6.12139C6.21816 25.0685 6.28931 25.0568 6.33485 25.0332C6.38039 25.0086 6.40316 24.9728 6.40316 24.9257C6.40316 24.8807 6.37944 24.8454 6.332 24.8197C6.28646 24.794 6.21626 24.7812 6.12139 24.7812H5.8197V25.0685Z",
    fill: "url(#paint7_linear_996_3560)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16134 24.778C8.29226 24.778 8.40895 24.7967 8.51141 24.8342C8.61577 24.8706 8.69736 24.9235 8.75618 24.9931C8.8169 25.0616 8.84726 25.1429 8.84726 25.2371C8.84726 25.3302 8.8169 25.4115 8.75618 25.4811C8.69736 25.5506 8.61577 25.6041 8.51141 25.6416C8.40895 25.678 8.29226 25.6962 8.16134 25.6962C8.0399 25.6962 7.93554 25.6807 7.84826 25.6496C7.76098 25.6186 7.69742 25.5763 7.65757 25.5228V26.1119H7.17088V24.7892H7.65757V24.9514C7.69742 24.8978 7.76098 24.8556 7.84826 24.8245C7.93554 24.7935 8.0399 24.778 8.16134 24.778ZM8.0048 25.0188C7.90234 25.0188 7.8179 25.0386 7.75149 25.0782C7.68698 25.1167 7.65472 25.1697 7.65472 25.2371C7.65472 25.3034 7.68698 25.3564 7.75149 25.396C7.8179 25.4356 7.90234 25.4554 8.0048 25.4554C8.10916 25.4554 8.19265 25.4361 8.25526 25.3976C8.31977 25.3591 8.35203 25.3056 8.35203 25.2371C8.35203 25.1686 8.31977 25.1151 8.25526 25.0766C8.19265 25.038 8.10916 25.0188 8.0048 25.0188Z",
    fill: "url(#paint8_linear_996_3560)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99707 32.5702H7.75215V34.8241C7.75215 35.1197 7.9859 35.3313 8.22669 35.4736C8.48387 35.6256 8.83971 35.754 9.25795 35.8586C10.0982 36.0686 11.246 36.1959 12.5048 36.1959C13.7636 36.1959 14.9114 36.0686 15.7516 35.8586C16.1699 35.754 16.5257 35.6256 16.7829 35.4736C17.0237 35.3313 17.2575 35.1197 17.2575 34.8241V32.5702H17.0125H16.7676C16.7676 32.5858 16.7491 32.6707 16.5337 32.798C16.3346 32.9157 16.0303 33.0301 15.6328 33.1295C14.8416 33.3273 13.7356 33.4522 12.5048 33.4522C11.274 33.4522 10.168 33.3273 9.37676 33.1295C8.97926 33.0301 8.67496 32.9157 8.47593 32.798C8.26051 32.6707 8.24199 32.5858 8.24199 32.5702H7.99707Z",
    fill: "#F7CC74",
    stroke: "url(#paint9_linear_996_3560)",
    strokeWidth: 0.489848
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99707 30.3163H7.75215V32.5702C7.75215 32.8659 7.9859 33.0774 8.22669 33.2197C8.48387 33.3717 8.83971 33.5001 9.25795 33.6047C10.0982 33.8147 11.246 33.9421 12.5048 33.9421C13.7636 33.9421 14.9114 33.8147 15.7516 33.6047C16.1699 33.5001 16.5257 33.3717 16.7829 33.2197C17.0237 33.0774 17.2575 32.8659 17.2575 32.5702V30.3163H17.0125H16.7676C16.7676 30.3319 16.7491 30.4168 16.5337 30.5442C16.3346 30.6618 16.0303 30.7762 15.6328 30.8756C14.8416 31.0734 13.7356 31.1984 12.5048 31.1984C11.274 31.1984 10.168 31.0734 9.37676 30.8756C8.97926 30.7762 8.67496 30.6618 8.47593 30.5442C8.26051 30.4168 8.24199 30.3319 8.24199 30.3163H7.99707Z",
    fill: "#F7CC74",
    stroke: "url(#paint10_linear_996_3560)",
    strokeWidth: 0.489848
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99707 28.0625H7.75215V30.3163C7.75215 30.612 7.9859 30.8235 8.22669 30.9658C8.48387 31.1178 8.83971 31.2462 9.25795 31.3508C10.0982 31.5609 11.246 31.6882 12.5048 31.6882C13.7636 31.6882 14.9114 31.5609 15.7516 31.3508C16.1699 31.2462 16.5257 31.1178 16.7829 30.9658C17.0237 30.8235 17.2575 30.612 17.2575 30.3163V28.0625H17.0125H16.7676C16.7676 28.078 16.7491 28.1629 16.5337 28.2903C16.3346 28.4079 16.0303 28.5223 15.6328 28.6217C14.8416 28.8195 13.7356 28.9445 12.5048 28.9445C11.274 28.9445 10.168 28.8195 9.37676 28.6217C8.97926 28.5223 8.67496 28.4079 8.47593 28.2903C8.26051 28.1629 8.24199 28.078 8.24199 28.0625H7.99707Z",
    fill: "#F7CC74",
    stroke: "url(#paint11_linear_996_3560)",
    strokeWidth: 0.489848
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5048 26.6906C11.246 26.6906 10.0982 26.8179 9.25795 27.028C8.83971 27.1326 8.48387 27.261 8.22669 27.413C7.9859 27.5553 7.75215 27.7668 7.75215 28.0625C7.75215 28.3581 7.9859 28.5697 8.22669 28.712C8.48387 28.864 8.83971 28.9924 9.25795 29.097C10.0982 29.307 11.246 29.4343 12.5048 29.4343C13.7636 29.4343 14.9114 29.307 15.7516 29.097C16.1699 28.9924 16.5257 28.864 16.7829 28.712C17.0237 28.5697 17.2575 28.3581 17.2575 28.0625C17.2575 27.7668 17.0237 27.5553 16.7829 27.413C16.5257 27.261 16.1699 27.1326 15.7516 27.028C14.9114 26.8179 13.7636 26.6906 12.5048 26.6906Z",
    fill: "#FFDF9D",
    stroke: "url(#paint12_linear_996_3560)",
    strokeWidth: 0.489848
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7177 28.4608L11.2823 28.0322H11.1713V28.4608H10.6846V27.3259H11.5156C11.675 27.3259 11.8097 27.3414 11.9198 27.3725C12.0298 27.4035 12.1124 27.4463 12.1674 27.5009C12.2224 27.5544 12.2499 27.6159 12.2499 27.6855C12.2499 27.7679 12.2092 27.838 12.1276 27.8958C12.0479 27.9536 11.9312 27.9932 11.7775 28.0146L12.2556 28.4608H11.7177ZM11.1713 27.8444H11.473C11.5697 27.8444 11.6409 27.8326 11.6864 27.8091C11.732 27.7845 11.7547 27.7486 11.7547 27.7016C11.7547 27.6566 11.731 27.6213 11.6836 27.5956C11.638 27.5699 11.5678 27.5571 11.473 27.5571H11.1713V27.8444Z",
    fill: "url(#paint13_linear_996_3560)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5129 27.5539C13.6438 27.5539 13.7605 27.5726 13.863 27.6101C13.9673 27.6464 14.0489 27.6994 14.1077 27.769C14.1685 27.8375 14.1988 27.9188 14.1988 28.013C14.1988 28.1061 14.1685 28.1874 14.1077 28.257C14.0489 28.3265 13.9673 28.38 13.863 28.4175C13.7605 28.4539 13.6438 28.4721 13.5129 28.4721C13.3915 28.4721 13.2871 28.4565 13.1998 28.4255C13.1125 28.3945 13.049 28.3522 13.0091 28.2987V28.8878H12.5224V27.5651H13.0091V27.7272C13.049 27.6737 13.1125 27.6315 13.1998 27.6004C13.2871 27.5694 13.3915 27.5539 13.5129 27.5539ZM13.3564 27.7947C13.2539 27.7947 13.1695 27.8145 13.1031 27.854C13.0385 27.8926 13.0063 27.9455 13.0063 28.013C13.0063 28.0793 13.0385 28.1323 13.1031 28.1719C13.1695 28.2115 13.2539 28.2313 13.3564 28.2313C13.4607 28.2313 13.5442 28.212 13.6068 28.1735C13.6713 28.135 13.7036 28.0815 13.7036 28.013C13.7036 27.9445 13.6713 27.891 13.6068 27.8524C13.5442 27.8139 13.4607 27.7947 13.3564 27.7947Z",
    fill: "url(#paint14_linear_996_3560)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.8299,
    cy: 23.4815,
    rx: 5.55161,
    ry: 0.653131,
    fill: "url(#paint15_radial_996_3560)",
    fillOpacity: 0.4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8455 1.36698L44.0045 4.52325L43.928 4.95431C43.5335 7.17744 42.2351 9.65685 39.9341 10.4387C38.704 10.8567 37.6077 11.5287 37.2275 12.8104C36.8549 14.0665 37.3611 15.1721 38.1393 16.2156C39.5921 18.1637 39.2569 20.9424 38.3221 22.9977L38.1409 23.3962L27.9819 20.2399L28.0584 19.8088C28.4529 17.5857 29.7513 15.1063 32.0522 14.3244C33.2848 13.9056 34.3283 13.2815 34.7332 12.0354C35.1462 10.7639 34.6237 9.58907 33.847 8.54754C32.3942 6.59942 32.7295 3.82078 33.6642 1.7655L33.8455 1.36698ZM34.3979 2.57856C33.6778 4.40965 33.5856 6.53575 34.6431 7.95385C35.4814 9.07797 36.2428 10.6027 35.6777 12.3422C35.1248 14.0442 33.6971 14.8144 32.3717 15.2647C30.6968 15.8339 29.5679 17.6379 29.1237 19.5547L37.5884 22.1846C38.3086 20.3535 38.4008 18.2274 37.3432 16.8093C36.5064 15.6872 35.7665 14.2436 36.2754 12.528C36.7956 10.7744 38.2869 9.94959 39.6146 9.49843C41.2896 8.92927 42.4184 7.12525 42.8627 5.20845L34.3979 2.57856Z",
    fill: "#2CC96F",
    stroke: "url(#paint16_linear_996_3560)",
    strokeWidth: 0.163283,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.3164,
    y: 0.560959,
    width: 11.9526,
    height: 1.22707,
    rx: 0.57149,
    transform: "rotate(17.2593 33.3164 0.560959)",
    fill: "#2ECC71",
    stroke: "url(#paint17_linear_996_3560)",
    strokeWidth: 0.163283
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5977,
    y: 18.9596,
    width: 11.9526,
    height: 1.22707,
    rx: 0.57149,
    transform: "rotate(17.2593 27.5977 18.9596)",
    fill: "#2ECC71",
    stroke: "url(#paint18_linear_996_3560)",
    strokeWidth: 0.163283
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2472 4.50291L38.1524 4.47345L34.833 3.44217C34.4303 4.7383 34.0761 7.88671 37.1109 8.82959C40.1458 9.77248 41.6381 6.97765 42.0408 5.68152L38.2472 4.50291Z",
    fill: "url(#paint19_linear_996_3560)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7626 20.2691L33.8574 20.2986L37.1768 21.3299C37.5794 20.0337 37.9337 16.8853 34.8988 15.9424C31.864 14.9996 30.3717 17.7944 29.969 19.0905L33.7626 20.2691Z",
    fill: "url(#paint20_linear_996_3560)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_996_3560",
    x1: 9.18649,
    y1: 2.32006,
    x2: 37.5463,
    y2: 23.4255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E136C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204995"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_996_3560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6049 35.916) rotate(90) scale(1.63283 6.85787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CC74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_996_3560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.70651 32.8136) rotate(90) scale(1.63283 6.85787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CC74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_996_3560",
    x1: 7.15324,
    y1: 29.7943,
    x2: 7.15324,
    y2: 33.1751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_996_3560",
    x1: 7.15324,
    y1: 27.5405,
    x2: 7.15324,
    y2: 30.9213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_996_3560",
    x1: 7.15324,
    y1: 25.2866,
    x2: 7.15324,
    y2: 28.6674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_996_3560",
    x1: 7.15324,
    y1: 24.1597,
    x2: 7.15324,
    y2: 26.4135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_996_3560",
    x1: 7.09013,
    y1: 24.55,
    x2: 7.09013,
    y2: 26.1119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_996_3560",
    x1: 7.09013,
    y1: 24.55,
    x2: 7.09013,
    y2: 26.1119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_996_3560",
    x1: 12.5048,
    y1: 32.5702,
    x2: 12.5048,
    y2: 35.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_996_3560",
    x1: 12.5048,
    y1: 30.3163,
    x2: 12.5048,
    y2: 33.6971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_996_3560",
    x1: 12.5048,
    y1: 28.0625,
    x2: 12.5048,
    y2: 31.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_996_3560",
    x1: 12.5048,
    y1: 26.9355,
    x2: 12.5048,
    y2: 29.1894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_996_3560",
    x1: 12.4417,
    y1: 27.3259,
    x2: 12.4417,
    y2: 28.8878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_996_3560",
    x1: 12.4417,
    y1: 27.3259,
    x2: 12.4417,
    y2: 28.8878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_996_3560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.8299 23.4815) rotate(90) scale(0.653131 5.55161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ECC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ECC71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_996_3560",
    x1: 38.925,
    y1: 2.94512,
    x2: 33.0614,
    y2: 21.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ECC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AAF59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_996_3560",
    x1: 39.3206,
    y1: 0.458771,
    x2: 39.3206,
    y2: 1.84912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ECC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AAF59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_996_3560",
    x1: 33.6019,
    y1: 18.8575,
    x2: 33.6019,
    y2: 20.2478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ECC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AAF59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_996_3560",
    x1: 34.6268,
    y1: 4.10604,
    x2: 37.7555,
    y2: 8.0939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ECC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ECC71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_996_3560",
    x1: 37.383,
    y1: 20.666,
    x2: 34.2543,
    y2: 16.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ECC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ECC71",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnTimePayment);
export default __webpack_public_path__ + "static/media/on-time-payment.f6dd6dc244d1d09a9dd46637fc320f0a.svg";
export { ForwardRef as ReactComponent };